import {
  TGroupTransformInput,
  TTransformedGroup,
} from '@/shared/features/groups/hooks/use-group-transformer/use-group-transformer.types';

export const useGroupTransformer = () => {
  const transformGroup = <T extends TGroupTransformInput>(
    item: T,
  ): TTransformedGroup<T> => ({
    groupId: item.groupId,
    name: item.name,
    createdAt: item.creationTimestamp,
    createdBy: item.creationUser,
    raw: item,
  });

  return { transformGroup };
};
